// TODO: Ensure that this is updated to come from the actual database

export const toolList = [
  {
  label: "Wordpress",
  value: "wordpress",
  icon: "",
  id: 19
  },
  {
  label: "Illustrator",
  value: "illustrator",
  icon: "",
  id: 18
  },
  {
  label: "Photoshop",
  value: "photoshop",
  icon: "",
  id: 17
  },
  {
  label: "Sketch",
  value: "sketch",
  icon: "",
  id: 16
  },
  {
  label: "Invision",
  value: "invision",
  icon: "",
  id: 15
  },
  {
  label: "Basecamp",
  value: "basecamp",
  icon: "",
  id: 14
  },
  {
  label: "Google Analytics",
  value: "google_analytics",
  icon: "",
  id: 13
  },
  {
  label: "KissMetrics",
  value: "kissmetrics",
  icon: "",
  id: 12
  },
  {
  label: "Google Drive",
  value: "google_drive",
  icon: "",
  id: 11
  },
  {
  label: "Dropbox",
  value: "dropbox",
  icon: "",
  id: 10
  },
  {
  label: "Hangouts",
  value: "hangouts",
  icon: "",
  id: 9
  },
  {
  label: "Skype",
  value: "skype",
  icon: "",
  id: 8
  },
  {
  label: "Salesforce",
  value: "salesforce",
  icon: "",
  id: 7
  },
  {
  label: "Toggl",
  value: "toggl",
  icon: "",
  id: 6
  },
  {
  label: "Pivotal Tracker",
  value: "pivotal_tracker",
  icon: "",
  id: 5
  },
  {
  label: "Youtrack",
  value: "youtrack",
  icon: "",
  id: 4
  },
  {
  label: "Jira",
  value: "jira",
  icon: "",
  id: 3
  },
  {
  label: "Trello",
  value: "trello",
  icon: "",
  id: 2
  },
  {
  label: "Slack",
  value: "slack",
  icon: "",
  id: 1
  }
  ]